var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelkProdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "selkProdLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(-596.604 -552.489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(596.604 552.489)",
    fill: "#b0b6be"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(-828.332 -329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M136.508,115.5H120.9c.075.373.224.747.3,1.045a27.448,27.448,0,0,1,.971,5.6c.075.747.075,1.568.075,2.315s0,1.568-.075,2.315a27.447,27.447,0,0,1-.971,5.6c-.075.373-.224.747-.3,1.045h15.608a8.962,8.962,0,0,0,0-17.923Z",
    transform: "translate(742.565 242.41)",
    fill: "#00a9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M113.534,126.776c.075-.747.075-1.568.075-2.315s0-1.568-.075-2.315a27.447,27.447,0,0,0-.971-5.6c-.075-.373-.224-.747-.3-1.045H88.144a30.543,30.543,0,0,0,0,17.922h24.121c.075-.373.224-.747.3-1.045A27.448,27.448,0,0,0,113.534,126.776Z",
    transform: "translate(751.2 242.41)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M135.094,143.5H115.678a30.7,30.7,0,0,1-2.016,3.809,28.988,28.988,0,0,1-3.958,5.078c-.523.523-1.045.971-1.568,1.494a29.715,29.715,0,0,1-3.435,2.614,29.553,29.553,0,0,0,16.429,4.929A29.934,29.934,0,0,0,146,148.13,15.23,15.23,0,0,0,135.094,143.5Z",
    transform: "translate(746.667 235.319)",
    fill: "#00bfb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M109.964,147.309a30.7,30.7,0,0,0,2.016-3.809H90.1a29.527,29.527,0,0,0,10.978,12.994,37.878,37.878,0,0,0,3.435-2.614c.523-.448,1.045-.971,1.568-1.494a29.433,29.433,0,0,0,3.883-5.078Z",
    transform: "translate(750.364 235.319)",
    fill: "#019b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M105.981,98.207c-.523-.523-1.045-.971-1.568-1.494a29.711,29.711,0,0,0-3.435-2.614A30.528,30.528,0,0,0,90,107.094h21.88a30.7,30.7,0,0,0-2.016-3.809,23.485,23.485,0,0,0-3.883-5.078Z",
    transform: "translate(750.39 247.829)",
    fill: "#f9b110"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M121.129,87.5A29.553,29.553,0,0,0,104.7,92.429a37.882,37.882,0,0,1,3.435,2.614c.523.448,1.045.971,1.568,1.494a28.988,28.988,0,0,1,3.958,5.078,30.7,30.7,0,0,1,2.016,3.809h19.416a15.23,15.23,0,0,0,10.9-4.63A29.934,29.934,0,0,0,121.129,87.5Z",
    transform: "translate(746.667 249.5)",
    fill: "#fed10a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelkProdLogo);
export default __webpack_public_path__ + "static/media/selkProdLogo.e0a2d703ec52f84df1b52d0af15dd66a.svg";
export { ForwardRef as ReactComponent };